import { createContext } from "solid-js";
let ThemeContext;
if (process.env.NODE_ENV !== "production") {
    const global = globalThis;
    const suid = global.__suid || (global.__suid = {});
    ThemeContext =
        suid.systemThemeContext || (suid.systemThemeContext = createContext({}));
}
else {
    ThemeContext = createContext({});
}
export default ThemeContext;
